var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-rotate-image-control"
  }, [_c('div', {
    staticClass: "ugc-rotate-image-control-value",
    attrs: {
      "id": "rotateLabel"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.RotateValue) + "°\n  ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.RotateValue,
      expression: "RotateValue"
    }],
    staticClass: "ugc-rotate-image-control-input",
    attrs: {
      "type": "range",
      "min": "-360",
      "max": "360",
      "role": "slider",
      "aria-labelledby": "rotateLabel",
      "aria-valuemin": "-360",
      "aria-valuemax": "360",
      "aria-valuenow": _vm.RotateValue
    },
    domProps: {
      "value": _vm.RotateValue
    },
    on: {
      "input": _vm.onInputChange,
      "__r": function __r($event) {
        _vm.RotateValue = $event.target.value;
      }
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }